import { ReplyIcon } from 'morpheus-ui';
import { Button } from '../../../../atoms/Button';
import { Typography } from '../../../../molecules/Typography';
import { ICommentAPI } from '../../index';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface ICommentContent {
  data: ICommentAPI;
  onReply: () => void;
  onLike: () => void;
  disableReply?: boolean;
  isModal?: boolean;
}

export default function CommentContent({
  data,
  onReply,
  onLike,
  disableReply,
  isModal = false,
}: ICommentContent) {
  return (
    <div
      className={`flex w-full flex-col gap-lg break-words rounded-md p-5 ${
        isModal ? 'bg-color-lighter' : 'bg-color-lightest'
      }`}
    >
      <Typography size='h6' type='title' weight='bold' className=''>
        {data?.user?.name}
      </Typography>
      <Typography size='default'>{data.text}</Typography>
      <div className='flex flex-row items-end justify-between'>
        <Typography size='small'>
          {formatDistanceToNow(new Date(data.createdAt), {
            addSuffix: true,
            locale: ptBR,
          })}
        </Typography>
        <div className='flex flex-row items-end gap-xxl'>
          <div className='flex flex-row items-end gap-sm'>
            <Typography size='default'>
              {data.qtdLikes < 10 && '0'}
              {data.qtdLikes}
            </Typography>

            <Button
              onlyIcon
              LeftIcon='thumb_up'
              iconType='material'
              iconVariant='rounded'
              classNameIcon={`filled ${
                data.isLiked
                  ? 'text-brand-color-secondary-pure'
                  : 'text-mono-color-medium'
              }`}
              size='regular'
              variant='text'
              className='filled p-0'
              onClick={() => {
                onLike();
              }}
            />
          </div>
          {!disableReply && (
            <Button
              onlyIcon
              LeftIcon={ReplyIcon}
              iconType='svg'
              iconVariant='rounded'
              classNameIcon={`h-4 w-4 fill-button-color-tertiary-default`}
              size='small'
              variant='text'
              className='p-0'
              onClick={() => onReply()}
            />
          )}
        </div>
      </div>
    </div>
  );
}
